import SectionHeading from './SectionHeading';
import { guideSteps } from '@/mocks/home';

export default function GettingStarted() {
  return (
    <section id="getting-started" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
        <div>
          <SectionHeading
            eyebrow="Getting Started"
            title="第一次使用，按这五步走"
            desc="很多问题其实来自操作顺序。先确认入口，再浏览内容，最后才是登录与设置，基本能避免大部分困扰。"
          />
          <div className="mt-8 hidden overflow-hidden rounded-2xl border border-background-200 lg:block">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20minimal%20desk%20scene%20with%20a%20hand%20tapping%20a%20smartphone%20showing%20a%20video%20streaming%20library%20among%20warm%20amber%20lamp%20light%2C%20deep%20red%20accent%20tones%2C%20editorial%20technology%20photography%2C%20clean%20calm%20composition%2C%20soft%20neutral%20background&width=900&height=760&seq=guide-hongtao-02&orientation=landscape"
              alt="按步骤使用红桃影视的操作示意"
              className="h-auto w-full object-top"
            />
          </div>
        </div>

        <ol className="relative space-y-4 border-l border-background-200 pl-6">
          {guideSteps.map((s) => (
            <li key={s.step} className="relative">
              <span className="absolute -left-[34px] flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-[11px] font-bold text-background-50">
                {s.step}
              </span>
              <div className="rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300">
                <h3 className="font-heading text-base font-semibold text-foreground-950">{s.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}